export default __webpack_public_path__ + "static/media/money-bag-svgrepo-com.e6d70306.svg";